import React from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import {
  withRouter,
  Link
} from 'react-router-dom';
import history from '../../navigation/history';
import SearchBar from '../../components/ui/search/SearchBar';
import SearchTable from '../../components/ui/search/SearchTable';
import SearchSortTitle from '../../components/ui/search/SearchSortTitle';
import EmployeeSortBy from '../../constants/EmployeeSortBy';

import * as actions from '../../redux/actions';
import {
  PageHeader,
  Button
} from 'antd'
import {
  DashboardContainer,
  PageTitle
} from '../styles';


class Employees extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCatalog: false,
      query: '',
      pagination: { current: 1 },
      selectedOrder: 0
    }
  }
  componentWillMount() {
    this.props.searchEmployees('', 1, EmployeeSortBy[0])
  }

  selectTableColumns() {
    let columns = [
      {
        title: 'Name',
        dataIndex: '',
        key: '',
        render: (data) => <Link to={`/employees/${data.id}`}>{data.name}</Link>,
      },
    ]

    //Table columns
    if(window.outerWidth > 992) {
      columns = [
        {
          title: () =>
          <SearchSortTitle
            title='Name'
            updateState={(key, value) => this.updateState(key, value)}
            selectedOrder={this.state.selectedOrder}
            upIndex={0}
            downIndex={1}
          />,
          dataIndex: '',
          key: '',
          render: (data) => <Link to={`/employees/${data.id}`}>{data.name}</Link>,
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
        },
        {
          title: 'Created Date',
          dataIndex: 'createdAt',
          key: 'createdAt'
        },
      ];
    }

    return columns

  }
  updateState(key, value) {
    if(value === '') {
      this.props.searchEmployees(value, 1, EmployeeSortBy[this.state.selectedOrder])
    } else if(key === 'selectedOrder') {
      this.props.searchEmployees(this.state.query, this.state.pagination.current, EmployeeSortBy[value])
    }
    this.setState({
      [key]: value,
      pagination: { current: 1 }
    })
  }

  onTableChange(pagination) {
    const { query } = this.state;
    this.setState({
      pagination
    })
    this.props.searchEmployees(query, pagination.current, EmployeeSortBy[this.state.selectedOrder])

  }


  render() {
    //Table columns
    const columns = this.selectTableColumns()
      return (
        <DashboardContainer>
          <PageHeader
            title={<PageTitle>Employees</PageTitle>}
            breadcrumb={null}
            style={{ background: 'transparent' }}
            extra={[
              <Button
                key="1"
                type="primary"
                onClick={() => history.push('/employees/add')}
                id='addBtn'
              >
                Add
              </Button>,
            ]}
          />
          <SearchBar
            updateState={(key, value) => this.updateState(key, value)}
            query={this.state.query}
            searchPlaceholder='Search Employees By Email or Name'
            onSearch={() => this.props.searchEmployees(this.state.query, this.state.pagination.current,EmployeeSortBy[this.state.selectedOrder])}
            loading={this.props.employeeData.loadingSearchEmployees}
          />
          <SearchTable
            data={this.props.employeeData.searchEmployees}
            columns={columns}
            loading={this.props.employeeData.loadingSearchEmployees}
            pagination={{ total: this.props.employeeData.searchEmployeesCount, defaultCurrent: 1, current: this.state.pagination.current }}
            onChange={(pagination) => this.onTableChange(pagination)}
          />

        </DashboardContainer>
      );
  }
}
function mapStateToProps(state, props) {
    return {
        auth: state.AuthReducer,
        employeeData: state.EmployeeReducer,
        inventoryData: state.InventoryReducer,
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(actions, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Employees));
